
import { granjaApi } from "../../api";
import { useBodegasStore } from "../../store";

import Swal from "sweetalert2";







export const startBodegaXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/bodega/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}



export const startListadoBodegas = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        const { data } = await granjaApi.get('/bodega', { params });
        useBodegasStore.setState({ totalBodega: data.total });

        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const bodegasXGranja = async( id ) => {
    try {
        const { data } = await granjaApi.get(`/bodega/xgranja/${id}`);
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}





export const startSavingBodega = async(bodega) => {
    try {
        if( bodega.id ){
            await granjaApi.put(`/bodega/${ bodega.id }`, bodega );
            Swal.fire('Exitoso', 'Bodega Actualizada', 'success');
        }else {
            await granjaApi.post('/bodega/new', bodega);
            Swal.fire('Exitoso', 'Bodega Creada', 'success');
            return true;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 

